import type { ElementType } from 'react';
import { Cpu, Code2, Database, Sparkles } from 'lucide-react';

export interface Skill {
  name: string;
  icon: ElementType;
  items: string[];
}

export const skillsData: Skill[] = [
  {
    name: 'Embedded & hardware',
    icon: Cpu,
    items: [
      'C / C++ / Python (test automation, internal tooling, hardware-in-the-loop workflows)',
      'Assembly (basic)',
      'EtherCAT · BLE · UART · I2C · SPI',
      'TMS320F28379D (C2000) · PID control',
      'Oscilloscope · DAQ · soldering',
    ],
  },
  {
    name: 'Web & mobile',
    icon: Code2,
    items: [
      'React · React Native / Expo',
      'TypeScript · JavaScript',
      'FastAPI · REST APIs · WebSockets',
    ],
  },
  {
    name: 'Data & cloud',
    icon: Database,
    items: [
      'PostgreSQL · Supabase',
      'MongoDB',
      'Serverless functions',
      'Row-level security · authentication',
    ],
  },
  {
    name: 'AI & tools',
    icon: Sparkles,
    items: [
      'OpenAI APIs',
      'Claude Code · Cursor · Codex',
      'Git · Jira',
      'Pytest · Figma',
    ],
  },
];
